import React, { useState } from 'react';
import { PencilSquareIcon, TrashIcon, EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import TimeSlot from './time_slot';
import { getShiftDuration, formatHoursAndMinutes, getShiftDurationWithMidnight } from '../utils/workTimeCount';

const toMinutes = (time) => {
  if (!time) return 0;
  const [h, m] = time.split(':').map(Number);
  return h * 60 + m;
};


// ANTEPRIMA CREAZIONE TURNO GIORNALIERO

const DailyShiftPreviewTable = ({ shiftPreviews, onDeleteShift, onShiftPreview, onEditingTimeSlot, allowHiddenBreaks, onAssignWh }) => {
  const [editingIndex, setEditingIndex] = useState(null);
  const isAssignWh = onAssignWh === 'assignWhComponent';

  const handleDeleteShift = (index) => {
    onDeleteShift(index);
  };

  const handleEditShift = (index) => {
    setEditingIndex(index);
    if (onEditingTimeSlot) onEditingTimeSlot(index);
  };

  const close = () => {
    setEditingIndex(null);
    if (onEditingTimeSlot) onEditingTimeSlot(null);
  };

  // copia ordinata, ma mi tengo l'indice originale (__index)
  const sortedPreviews = shiftPreviews
    .map((preview, originalIndex) => ({ ...preview, __index: originalIndex }))
    .sort((a, b) => {
      const aKey = toMinutes(a.workStartTime) + (a.nextDay ? 1440 : 0);
      const bKey = toMinutes(b.workStartTime) + (b.nextDay ? 1440 : 0);
      return aKey - bKey;
    });

  const totalDuration = shiftPreviews.reduce((acc, preview) => {
    const { workStartTime, workEndTime } = preview || {};

    const isCrossMidnight =
      isAssignWh &&
      workStartTime &&
      workEndTime &&
      workEndTime < workStartTime;

    const duration = isCrossMidnight
      ? getShiftDurationWithMidnight(preview)
      : getShiftDuration(preview);

    return acc + duration;
  }, 0);

  return (
    <>
      {shiftPreviews.length > 0 && (
        <div className="mt-4 p-5 pb-0 border border-solid-2 border-gray-200 rounded-md shadow-md bg-white w-full mb-4">
          <h2 className="text-sm font-medium text-gray-700 mb-2 text-left">
            ANTEPRIMA TURNO
          </h2>
          <table className="min-w-full divide-y divide-gray-200 border border-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-1 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider w-1/4">
                  Inizio Fascia Oraria
                </th>
                <th className="px-1 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider w-1/4">
                  Pausa
                </th>
                <th className="px-1 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider w-1/4">
                  Fine Fascia Oraria
                </th>
                <th className="px-1 py-3 text-center text-xs font-medium text-gray-900 uppercase tracking-wider w-1/4">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {sortedPreviews.map((preview, rowIndex) => (
                <tr key={rowIndex} className="bg-white text-center">
                  <td className="px-1 py-2 text-sm whitespace-nowrap text-gray-700">
                    {preview.workStartTime}
                  </td>

                  <td className="px-1 py-2 text-sm whitespace-nowrap text-gray-700">
                    {preview.breaks && preview.breaks.length > 0 ? (
                      preview.breaks.map((breakItem, breakIndex) => (
                        <div
                          key={breakIndex}
                          className={`flex justify-center items-center gap-2 ${
                            !breakItem?.is_visible ? 'text-gray-400' : 'text-gray-700'
                          }`}
                        >
                          {!breakItem?.is_visible && (
                            <EyeSlashIcon className="h-4 w-4 text-red-500" strokeWidth={2} />
                          )}
                          <span>
                            {breakItem.start_at} - {breakItem.end_at}
                          </span>
                        </div>
                      ))
                    ) : (
                      <span>-</span>
                    )}
                  </td>

                  <td className="px-1 py-2 text-sm whitespace-nowrap text-gray-700">
                    {preview.workEndTime}
                    {isAssignWh &&
                      preview.workStartTime &&
                      preview.workEndTime &&
                      preview.workEndTime < preview.workStartTime && (
                        <span className="text-xs text-gray-500 ml-1">
                          (giorno successivo)
                        </span>
                    )}
                  </td>

                  <td className="px-1 py-2 text-sm whitespace-nowrap">
                    <button
                      className="mr-2 text-gray-700 font-bold px-1"
                      title="Modifica"
                      onClick={() => handleEditShift(preview.__index)}
                    >
                      <PencilSquareIcon className="h-6 w-6 hover:text-indigo-600" />
                    </button>
                    <button
                      className="text-gray-700 font-bold px-1"
                      title="Elimina"
                      onClick={() => handleDeleteShift(preview.__index)}
                    >
                      <TrashIcon className="h-6 w-6 hover:text-red-500" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
            {shiftPreviews.length > 0 && (
              <div className='text-gray-700 text-sm font-semibold my-3 text-left'>Totale ore giornaliere:  {' '}
                {formatHoursAndMinutes(totalDuration)}
              </div>
            )}
        </div>
      )}
      {editingIndex !== null && (
        <TimeSlot
          shiftPreview={shiftPreviews[editingIndex]}
          onShiftPreview={(shiftData) => {
            onShiftPreview(shiftData, editingIndex);
            close();
          }}
          onCancelEdit={close}
          allowHiddenBreaks={allowHiddenBreaks}
          onAssignWh={onAssignWh}
        />
      )}
    </>
  );
};

export default DailyShiftPreviewTable;
